import GrmMediaStreamTrack from "@/lib/gooroomee/track-generator/GrmMediaStreamTrack";

(() => {
    if(!globalThis.MediaStreamTrack){
        return;
    }

    const GrmTrackUtils = function(track){
        this.track = track;
        track.GrmTrack = this;
        Object.assign(this, {
            getTrack () {
                return track;
            }
        });
    }

    // track generator
    Object.assign(GrmTrackUtils.prototype, {
        getTrackGenerator () {
            return this.getTrack()._grm_tg;
        },
        async pipeThrough (name, options) {
            this.getTrackGenerator().pipeThrough(name, options);
        },
        async setPipeOptions (name, options) {
            this.getTrackGenerator().setPipeOptions(name, options);
        }
    });

    // track methods
    Object.assign(GrmTrackUtils.prototype, {
        getOriTrack () {
            const oriTrack = this.getTrackGenerator().getSourceVideoMediaStreamTrack();
            return oriTrack;
        },
        getSettings () {
            return this.getOriTrack().getSettings();
        },
        getConstraints () {
            return this.getOriTrack().getConstraints();
        },
        async getDevice () {
            const deviceId = this.getDeviceId();
            if(!deviceId) return null;
            const devices = await navigator.mediaDevices.enumerateDevices();
            const device = devices.find(d => d.deviceId === deviceId);
            return device;
        },
        getDeviceId () {
            const settings = this.getSettings();
            return settings.deviceId;
        },
        equalsOriTrackDeviceId (track) {
            if(!track) return false;
            const deviceId = this.getDeviceId();
            return track.GrmTrackUtils().getDeviceId() === deviceId;
        }
    })

    Object.assign(MediaStreamTrack.prototype, {
        async convertToGrmTrack (options, options2) {
            const gen = await GrmMediaStreamTrack.create(options, options2);
            await gen.init();
            await gen.requestVideoFrameRender();

            const tTrack = gen.getVideoMediaStreamTrack();
            tTrack.GrmTrackUtils();
            return tTrack;
        },
        GrmTrackUtils () {
            if(!this.GrmTrack){
                new GrmTrackUtils(this);
            }
            return this.GrmTrack;
        }
    });
})();